import { useSearchParams } from 'react-router-dom';
import { clsx } from 'clsx';
import { CampaignAdsTab } from './CampaignAdsTab';
import { CampaignPersonasTab } from './CampaignPersonasTab';
import { CampaignFormulasTab } from './CampaignFormulasTab';

type Tab = 'ads' | 'personas' | 'formulas';

const TABS: { value: Tab; label: string }[] = [
  { value: 'ads', label: 'Ads' },
  { value: 'personas', label: 'Personas' },
  { value: 'formulas', label: 'Formulas' },
];

export function CampaignDrilldownTabs({ campaignId }: { campaignId: string }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = (searchParams.get('tab') ?? 'ads') as Tab;

  function setTab(t: Tab) {
    const next = new URLSearchParams(searchParams);
    next.set('tab', t);
    setSearchParams(next, { replace: true });
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white">
      <div className="flex border-b border-slate-200" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={tab === t.value}
            onClick={() => setTab(t.value)}
            className={clsx(
              'px-4 py-2.5 text-sm font-medium border-b-2 transition-colors',
              tab === t.value
                ? 'border-teal-500 text-teal-700'
                : 'border-transparent text-slate-500 hover:text-slate-700',
            )}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="p-4">
        {tab === 'ads' && <CampaignAdsTab campaignId={campaignId} />}
        {tab === 'personas' && <CampaignPersonasTab campaignId={campaignId} />}
        {tab === 'formulas' && <CampaignFormulasTab campaignId={campaignId} />}
      </div>
    </div>
  );
}
